import React from 'react';

function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="w-full">
      {/* Accent hairline */}
      <div className="h-px w-full bg-gradient-to-r from-pink-500/40 via-sky-500/40 to-transparent" />

      <div className="w-full border-t border-white/10 bg-neutral-900/60 backdrop-blur-xl">
        <div className="mx-auto max-w-7xl px-4 sm:px-6">
          <div className="py-5 flex flex-col items-center gap-3 text-center sm:flex-row sm:justify-between sm:text-left">
            {/* Links */}
            <nav className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-sm">
              <a
                className="text-neutral-300 hover:text-white hover:underline underline-offset-4 transition"
                href="/terms_conditions"
                target="_blank"
                rel="noreferrer"
              >
                Terms & Conditions
              </a>
              <a
                className="text-neutral-300 hover:text-white hover:underline underline-offset-4 transition"
                href="/privacy_policy"
                target="_blank"
                rel="noreferrer"
              >
                Privacy Policy
              </a>
            </nav>

            {/* Copyright */}
            <p className="text-xs text-neutral-400">
              © 
              {' '}
              {year}
              {' '}
              NEW MEDIA TECHNOLOGIES. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
